import { render, staticRenderFns } from "./nullData.vue?vue&type=template&id=6320508b&scoped=true&"
import script from "./nullData.vue?vue&type=script&lang=js&"
export * from "./nullData.vue?vue&type=script&lang=js&"
import style0 from "./nullData.vue?vue&type=style&index=0&id=6320508b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6320508b",
  null
  
)

export default component.exports